<template>
  <div id="store-edit" class="group-setup">
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>

    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-form v-if="!loading">
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-card class="pa-5" flat>
            <HeaderDividerBlock headerText="Edit Store"></HeaderDividerBlock>
            <v-row>
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Store Name*</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.store_name"
                  required
                  clearable
                  placeholder="Store Name*"
                ></v-text-field>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Branch*</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.branch_id"
                  required
                  clearable
                  placeholder="Select Branch*"
                  :items="branches"
                  item-text="name"
                  item-value="id"
                  disabled
                ></v-autocomplete>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Store Type</p>
                </v-col>
                <v-select
                  outlined
                  dense
                  v-model="form.type"
                  required
                  clearable
                  placeholder="Store Type"
                  :items="storeTypes"
                ></v-select>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Status</p>
                </v-col>
                <v-select
                  outlined
                  dense
                  v-model="form.status"
                  required
                  clearable
                  placeholder="Status*"
                  :items="statuses"
                  :disabled="form.is_default === 1 || form.is_default === true"
                ></v-select>
              </v-col>
            </v-row>

            <v-card-actions class="mt-10">
              <v-row>
                <v-col cols="12" md="10" xs="6"></v-col>
                <v-col cols="12" md="2" xs="6">
                  <v-btn
                    large
                    color="#00B3FF"
                    dark
                    depressed
                    block
                    @click="submit"
                    v-if="hasPermission('store.edit')"
                  >
                    Update Store
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { StoreService } from "@/services/store-service";
import { checkError } from "@/config/errors.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "EditStoreForm",
  components: {
    Alert,
    Snackbars,
    HeaderDividerBlock,
  },
  data: () => ({
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    form: {
      store_name: "",
      branch_id: "",
      type: "",
      status: "",
      is_default: false,
    },
    branches: [],
    storeTypes: ["Retail", "Wholesale"],
    statuses: ["ACTIVE", "INACTIVE"],
  }),
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },
  created() {
    this.fetchBranches();
    this.fetchStoreDetails();
  },
  methods: {
    async fetchStoreDetails() {
      this.loading = true;
      try {
        const storeId = this.$route.params.id;
        const response = await StoreService.getStoreById(storeId);
        this.form = response;
      } catch (error) {
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      this.loading = true;
      this.errors = null;
      try {
        const storeId = this.$route.params.id;
        const response = await StoreService.updateStore(this.form, storeId);
        this.succesMsg = response.message;
        this.snackbar = true;
        this.$router.push({ name: "Stores" });
      } catch (error) {
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loading = false;
      }
    },
    async fetchBranches() {
      try {
        const branches = await StoreService.getBranches();
        this.branches = branches.data;
      } catch (error) {
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      }
    },
    closeSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>

<style scoped></style>
